import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { useLanguage } from '../../context/LanguageContext';
import './ThemeToggle.css';

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const { t } = useLanguage();

  const nextMode = theme === 'dark' ? t.theme.light : t.theme.dark;
  const ariaLabel = t.theme.switchTo.replace('{{mode}}', nextMode);

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label={ariaLabel}
    >
      {theme === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
    </button>
  );
};

export default ThemeToggle;
